import { motion } from "framer-motion";
import { AlertCircle } from "lucide-react";

function DisclaimerModal({ onAccept }) {
  return (
    <motion.div 
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      className="fixed inset-0 backdrop-blur-md bg-black/60 flex items-center justify-center z-50 p-4"
    >
      <motion.div 
        initial={{ scale: 0.9, y: 20 }}
        animate={{ scale: 1, y: 0 }}
        className="bg-white dark:bg-gray-800 rounded-3xl shadow-2xl max-w-lg p-8 border border-gray-100 dark:border-gray-700"
      >
        <div className="flex items-center mb-4">
          <AlertCircle className="text-amber-500 mr-2" size={24} />
          <h2 className="text-2xl font-bold text-gray-800 dark:text-white">Haftungsausschluss</h2>
        </div>
        
        <p className="mb-6 text-gray-600 dark:text-gray-300 leading-relaxed">
          Diese App dient ausschließlich der groben Orientierung und ersetzt keine medizinische oder rechtliche Beratung.
          Die Berechnungen basieren auf vereinfachten Modellen und können von individuellen Faktoren abweichen.
          <br /><br />
          Die Ergebnisse sind nicht rechtsverbindlich. Nutzung auf eigene Verantwortung.
        </p>
        
        <motion.button
          whileTap={{ scale: 0.97 }}
          className="w-full bg-gradient-to-r from-green-500 to-emerald-600 hover:from-green-600 hover:to-emerald-700 text-white font-semibold py-3 px-4 rounded-xl shadow-md transition-all duration-200"
          onClick={onAccept}
        >
          Ich verstehe und akzeptiere
        </motion.button>
      </motion.div>
    </motion.div>
  );
}

export default DisclaimerModal;